import { renderRepeaterData } from 'public/crossSiteHandlers'
import wixWindow from 'wix-window'
import { sendBI } from 'public/BIModule'
import BI_EVENTS from 'public/BIEvents'
import { subscribeToBeInTheKnow } from 'backend/subscribe'
import { getFeaturedPosts, getPopularPosts, getRecentPosts } from 'backend/dataModule'

$w.onReady(async function () {
    await Promise.all([
        renderDataInAllPageRepeaters(),
        getAndSetFeaturedPosts(),
        getAndSetRecentPosts(),
        getAndSetPopularPosts(),
        handleShareStoryBannerBehaviour()
    ])
    // handleSiteBlogMenuSwitch()

})

function handleShareStoryBannerBehaviour() {
    $w('#shareStoryBtn').onClick(() => {
        sendBI(BI_EVENTS.BANNER_CLICK, {
            banner_title: 'Tell Us Your Story',
            banner_name: 'velo_blog_users_stories'
        })
        wixWindow.openLightbox('Velo Stories')
    })
}

async function getAndSetFeaturedPosts() {
    const featuredPosts = await getFeaturedPosts()

    renderFeaturedPostsData(featuredPosts)
    $w('#slideImage0').show()
}

async function getAndSetRecentPosts() {
    const recentPosts = await getRecentPosts()
    $w('#recentPosts').data = recentPosts
}

async function getAndSetPopularPosts() {
    const popularPosts = await getPopularPosts()
    $w('#popularPosts').data = popularPosts
}

function renderDataInAllPageRepeaters() {
    renderRepeaterData('recentPosts')
    renderRepeaterData('popularPosts', { renderExcerpt: true })
}

function renderFeaturedPostsData(featuredPosts) {
    const featuredPostsSlides = $w('#featuredPostsSlideshow').slides
    featuredPostsSlides.forEach((slide, index) => {
        $w(`#slideCategory${index}`).text = featuredPosts[index].categories[0].label !== 'Tutorials and Code Examples' ? featuredPosts[index].categories[0].label : 'Tutorials'
        $w(`#slideImage${index}`).src = featuredPosts[index].coverImage
        $w(`#slideImage${index}`).alt = featuredPosts[index].title
        $w(`#slideTitle${index}`).text = featuredPosts[index].title
        $w(`#slideExcerpt${index}`).text = featuredPosts[index].excerpt
        $w(`#slideButton${index}`).link = featuredPosts[index].postPageUrl
    })
}

export function subscribeNow() {
    $w('#errorMessage').hide()
    $w('#buttonSubscribeNow').label = 'Subscribe'
    $w('#buttonSubscribeNow').disable()
    if ($w('#checkboxSubscribe').checked && $w('#inputSubscribeNow').value.length > 4 && $w('#inputSubscribeNow').valid) {
        const userEmail = $w('#inputSubscribeNow').value

        subscribeToBeInTheKnow(userEmail).then(() => {
                $w('#inputSubscribeNow').value = ''
                $w('#thankYouMessage').show()
                $w('#buttonSubscribeNow').hide()
                $w('#inputSubscribeNow').hide()
            })
            .catch((error) => {
                $w('#errorMessage').show()
                $w('#errorMessage').text = 'You\'re already on our subscription list.'
                $w('#buttonSubscribeNow').enable()
            })
    } else {
        $w('#errorMessage').show()
        $w('#errorMessage').text = 'Please agree to terms and enter a valid email address'
        $w('#buttonSubscribeNow').enable()
    }
}